import { render } from "./CustomerReservations.vue?vue&type=template&id=c8470a72&scoped=true"
import script from "./CustomerReservations.vue?vue&type=script&lang=js"
export * from "./CustomerReservations.vue?vue&type=script&lang=js"

import "./CustomerReservations.vue?vue&type=style&index=0&id=c8470a72&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8470a72"]])

export default __exports__